<script setup lang="ts">
import type { ReplicasValues } from '~/types/search/types'

const emits = defineEmits<{
  'change-replica': [{ label: ReplicasValues; value: string }]
}>()

const { replicasFormatted, replicas, currentReplica } =
  useSearchReplicaFilters()

const defaultReplica =
  replicasFormatted.value.find((o) => o.value === currentReplica.value.value)
    ?.value || null

const selectedReplica = ref(defaultReplica)

const changeReplica = (replica: string) => {
  const currentReplica = replicas.value.find((r) => r.value === replica)
  if (currentReplica) emits('change-replica', currentReplica)
}
</script>

<template>
  <LazyBaseFormComponentsBaseMultiselect
    v-model="selectedReplica"
    :can-clear="false"
    :can-deselect="false"
    :height="24"
    :options="replicasFormatted"
    input-label="label"
    name="sortByClient"
    wrapper-class="multiselect-replica m-0 min-w-[210px]"
    @select="changeReplica"
  >
    <template #multiselect-singlelabel="{ value }">
      <div class="multiselect-single-label !pl-0">
        <span class="text-md">
          {{ $t('search.sort_by') }} {{ value.label }}
        </span>
      </div>
    </template>

    <template #multiselect-option="{ option }">
      <span class="text-md">
        {{ option.label }}
      </span>
    </template>
  </LazyBaseFormComponentsBaseMultiselect>
</template>

<style scoped>
:deep(.multiselect-wrapper) {
  @apply lg:justify-normal;
}
</style>
